document.documentElement.classList.add('js');

var $ = function (s, el) { return (el || document).querySelector(s); };
var $$ = function (s, el) { return [].slice.call((el || document).querySelectorAll(s)); };

/* ============ Soft-focus scroll reveals ============ */
var rootedIO = 'IntersectionObserver' in window
  ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          rootedIO.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .12 })
  : null;

function rootedObserve(scope) {
  $$('.soft:not(.is-in)', scope).forEach(function (el) {
    rootedIO ? rootedIO.observe(el) : el.classList.add('is-in');
  });
}

rootedObserve(document);
